module.exports = __webpack_public_path__ + "img/transaction-cost-icon.3bc64915.svg";